import type { ComponentEntry } from '../../core/common-types'

const entry: ComponentEntry = {
	componentType: 'ByocStyles',
	loadComponent: () => import('./ByocStyles.js' /* webpackChunkName: "ByocStyles" */),
}

export default entry
